var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "user-profile-header__wrapper" } },
    [
      _c("ci-contact-success-modal", {
        attrs: {
          guest: _vm.guest,
          email: _vm.senderEmail,
          confirmedGuest: _vm.confirmedGuest,
        },
      }),
      _c("ci-contact-form-modal", {
        attrs: { advisor: _vm.user },
        on: { formCreated: _vm.getSenderEmail },
      }),
      _c(
        "div",
        { staticClass: "fixed-bottom right p-3 d-md-none" },
        [
          _c("ci-button", {
            directives: [
              {
                name: "ci-visible-scrolled",
                rawName: "v-ci-visible-scrolled",
                value: { amount: 2, unit: "vp" },
                expression: "{ amount: 2, unit: 'vp' }",
              },
              { name: "ci-scroll-to-top", rawName: "v-ci-scroll-to-top" },
            ],
            attrs: {
              id: "scroll-up",
              variant: "filled-primary",
              size: "md",
              icon: "mdi-arrow-up",
              fab: true,
            },
          }),
        ],
        1
      ),
      _c(
        "header",
        {
          staticClass: "ci-card ci-section header offset p-0",
          attrs: { id: "user-profile-header" },
        },
        [
          _c("div", { staticClass: "user-profile-header__canvas" }, [
            _c(
              "div",
              { staticClass: "avatar ci-content-padding-l" },
              [
                _c(
                  "ci-user-avatar",
                  _vm._b(
                    {
                      staticClass: "flex-shrink-0",
                      attrs: { username: _vm.user.firstname },
                    },
                    "ci-user-avatar",
                    _vm.actionAttributes.avatar,
                    false
                  )
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            {
              staticClass:
                "user-profile-header__info ci-content-padding px-xs-3 px-md-0 px-lg-4",
            },
            [
              _c(
                "div",
                { staticClass: "row no-gutters justify-content-between" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-md-7 col-lg-8 d-flex d-md-none justify-content-end",
                    },
                    [
                      _c(
                        "ci-share",
                        _vm._b(
                          {},
                          "ci-share",
                          _vm.actionAttributes.sharing,
                          false
                        )
                      ),
                      _vm.showPolicies.edit
                        ? _c(
                            "ci-button",
                            _vm._b(
                              {
                                staticClass: "mr-2",
                                on: { click: _vm.handlePrivacyClick },
                              },
                              "ci-button",
                              _vm.actionAttributes.privacy,
                              false
                            )
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-md-7 col-lg-8 meta mt-3 mt-lg-0 format-words",
                    },
                    [
                      _vm.user.label_key && _vm.user.label_key != "private"
                        ? _c("h2", {
                            staticClass: "user-type pt-1 pt-md-0",
                            domProps: { textContent: _vm._s(_vm.typeMapping) },
                          })
                        : _vm._e(),
                      _c("h1", {
                        staticClass: "user-name my-1",
                        domProps: {
                          textContent: _vm._s(_vm.user.display_name),
                        },
                      }),
                      _c("div", {
                        staticClass: "company-details",
                        domProps: {
                          textContent: _vm._s(_vm.positionAndCompanyName),
                        },
                      }),
                      _vm.showPolicies.contact
                        ? [
                            _c(
                              "div",
                              { staticClass: "ci-user-profile-address" },
                              [
                                _c(
                                  "ci-router-link",
                                  {
                                    staticClass:
                                      "font-weight-semi cursor-pointer",
                                    attrs: { to: _vm.advisorSearchByLocation },
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(_vm.joinedAddress),
                                      },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        : [
                            _vm.showPolicies.contact
                              ? _c("div", {
                                  staticClass: "location",
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.user.location.zipcode
                                    ),
                                  },
                                })
                              : _vm._e(),
                          ],
                    ],
                    2
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-md-5 col-lg-4 mt-3 mt-lg-0 actions pr-md-4 pr-lg-0 right-area",
                    },
                    [
                      _vm.displayAdvisorCta
                        ? _c("ci-advisor-contact-cta", {
                            staticClass: "advisor-contact-cta",
                            attrs: {
                              "show-messaging": _vm.showPolicies.conversations,
                              "show-contact": _vm.showPolicies.contact,
                              advisor: _vm.user,
                            },
                            on: {
                              "send-message": _vm.handleMessagingClick,
                              "show-address": function ($event) {
                                return _vm.$bvModal.show(
                                  _vm.$bvModalList.ids.USER_CONTACT_MODAL
                                )
                              },
                              "show-contact-form": _vm.openContactForm,
                            },
                          })
                        : [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "row mb-0 mb-md-3 d-none d-md-flex justify-content-end",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col-auto d-none d-md-block" },
                                  [
                                    _c(
                                      "ci-share",
                                      _vm._b(
                                        {},
                                        "ci-share",
                                        _vm.actionAttributes.sharing,
                                        false
                                      )
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "row mb-0 mb-md-3 d-none d-md-flex",
                              },
                              [
                                _vm.showPolicies.edit
                                  ? _c(
                                      "div",
                                      { staticClass: "col" },
                                      [
                                        _c(
                                          "ci-button",
                                          _vm._b(
                                            {
                                              staticClass: "w-100",
                                              on: {
                                                click: _vm.handleEditClick,
                                              },
                                            },
                                            "ci-button",
                                            _vm.actionAttributes.edit,
                                            false
                                          )
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.showPolicies.conversations
                                  ? _c(
                                      "div",
                                      { staticClass: "col" },
                                      [
                                        _c(
                                          "ci-button",
                                          _vm._b(
                                            {
                                              directives: [
                                                {
                                                  name: "b-modal",
                                                  rawName: "v-b-modal",
                                                  value: `modal-direct-message--${_vm.user.id}`,
                                                  expression:
                                                    "`modal-direct-message--${user.id}`",
                                                },
                                              ],
                                              staticClass: "send-message w-100",
                                              on: {
                                                click: _vm.handleMessagingClick,
                                              },
                                            },
                                            "ci-button",
                                            _vm.actionAttributes.messaging,
                                            false
                                          )
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm.showPolicies.edit
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "row mb-0 mb-md-3 d-none d-md-flex",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "col" },
                                      [
                                        _c(
                                          "ci-button",
                                          _vm._b(
                                            {
                                              staticClass: "w-100",
                                              on: {
                                                click: _vm.handlePrivacyClick,
                                              },
                                            },
                                            "ci-button",
                                            _vm.actionAttributes.privacy,
                                            false
                                          )
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c("div", { staticClass: "row" }, [
                              _vm.showPolicies.contact
                                ? _c(
                                    "div",
                                    { staticClass: "col" },
                                    [
                                      _c(
                                        "ci-button",
                                        _vm._b(
                                          {
                                            directives: [
                                              {
                                                name: "b-modal",
                                                rawName: "v-b-modal",
                                                value:
                                                  _vm.$bvModalList.ids
                                                    .USER_CONTACT_MODAL,
                                                expression:
                                                  "$bvModalList.ids.USER_CONTACT_MODAL",
                                              },
                                            ],
                                            staticClass: "w-100",
                                            attrs: { variant: "outline-light" },
                                          },
                                          "ci-button",
                                          _vm.actionAttributes.contact,
                                          false
                                        )
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showPolicies.conversations
                                ? _c(
                                    "div",
                                    { staticClass: "col d-flex d-md-none" },
                                    [
                                      _c(
                                        "ci-button",
                                        _vm._b(
                                          {
                                            directives: [
                                              {
                                                name: "b-modal",
                                                rawName: "v-b-modal",
                                                value: `modal-direct-message--${_vm.user.id}`,
                                                expression:
                                                  "`modal-direct-message--${user.id}`",
                                              },
                                            ],
                                            staticClass:
                                              "send-message-mobile w-100",
                                            on: {
                                              click: _vm.handleMessagingClick,
                                            },
                                          },
                                          "ci-button",
                                          _vm.actionAttributes.messaging,
                                          false
                                        )
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col d-flex d-md-none flex-grow-0",
                                },
                                [
                                  _vm.showPolicies.edit
                                    ? _c(
                                        "ci-button",
                                        _vm._b(
                                          {
                                            on: { click: _vm.handleEditClick },
                                          },
                                          "ci-button",
                                          _vm.actionAttributes.edit,
                                          false
                                        )
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]),
                          ],
                    ],
                    2
                  ),
                ]
              ),
            ]
          ),
          _vm._t("default"),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }